import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { ILogged } from '../../interfaces/ILogged';
import { LoggedService } from '../../services/logged.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  public logged?: ILogged;
  public Etiquetas: {
    Tooltips: {
      Facebook: string,
      Twitter: string,
      Instagram: string,
      Linkedin: string,
      YouTube: string
    },

    CopyrightFooter: string
    CondicionesUso: {
      Link: string,
      Titulo: string
    },
    PoliticaDePrivacidad: {
      Link: string,
      Titulo: string
    },
    PieDeImprenta: {
      Link: string,
      Titulo: string
    },
    DetallesTecnicos: {
      Link: string,
      Titulo: string
    }

    SocialMedia: {
      Facebook: string,
      Twitter: string,
      Instagram: string,
      Linkedin: string,
      YouTube: string
    }
  }


  constructor(
    private loggedService: LoggedService,
    private configService: ConfigService) { }

  ngOnInit(): void {


    this.Etiquetas = {
      CopyrightFooter: this.configService.etiquetas.CopyrightFooter,
      CondicionesUso: {
        Link: this.configService.uri.CondicionesDeUso.Link,
        Titulo: this.configService.uri.CondicionesDeUso.Titulo
      },
      PoliticaDePrivacidad: {
        Link: this.configService.uri.PoliticaDePrivacidad.Link,
        Titulo: this.configService.uri.PoliticaDePrivacidad.Titulo
      },
      PieDeImprenta: {
        Link: this.configService.uri.PieDeImprenta.Link,
        Titulo: this.configService.uri.PieDeImprenta.Titulo
      },
      DetallesTecnicos: {
        Link: this.configService.uri.DetallesTecnicos.Link,
        Titulo: this.configService.uri.DetallesTecnicos.Titulo
      },

      Tooltips: {
        Facebook: this.configService.tooltips.Footer.Facebook,
        Twitter: this.configService.tooltips.Footer.Twitter,
        Instagram: this.configService.tooltips.Footer.Instagram,
        Linkedin: this.configService.tooltips.Footer.Linkedin,
        YouTube: this.configService.tooltips.Footer.YouTube,
      },

      SocialMedia: {
        Facebook: this.configService.uri.SocialMedia.Facebook,
        Twitter: this.configService.uri.SocialMedia.Twitter,
        Instagram: this.configService.uri.SocialMedia.Instagram,
        Linkedin: this.configService.uri.SocialMedia.Linkedin,
        YouTube: this.configService.uri.SocialMedia.YouTube,
      }
    }



  }


  isInRole(rol: string): boolean {

    return this.loggedService.isInRole(rol);
  }


  isLogged() {
    return this.loggedService.logged != null;
  }



}
